import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import CustomerPigmy from "./pigmyComponent/CustomerPigmy";
import CustomerLoan from "./loanComponent/CustomerLoan";
import CustomerPigmyCollection from "./pigmyComponent/CustomerPigmyCollectoins";
import CustomerLoanCollection from "./loanComponent/CustomerLoanCollections";

function OverviewTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs value={value} onChange={handleChange} aria-label="overview tabs">
        <Tab label="Pigmy" />
        <Tab label="Loans" />
        <Tab label="Loan Report" />
        <Tab label="Pigmy Report" />
      </Tabs>

      {/* Tab Panels */}
      {value === 0 && (
        <TabPanel>
          <CustomerPigmy setTabValue={setValue} />
        </TabPanel>
      )}
      {value === 1 && (
        <TabPanel>
          <CustomerLoan setTabValue={setValue} />
        </TabPanel>
      )}
      {value === 2 && (
        <TabPanel>
          <CustomerLoanCollection />
        </TabPanel>
      )}
      {value === 3 && (
        <TabPanel>
          <CustomerPigmyCollection />
        </TabPanel>
      )}
    </Box>
  );
}

function TabPanel({ children }) {
  return <Box sx={{ p: 3 }}>{children}</Box>;
}

export default OverviewTabs;
